export const ru = {
    mask: 'дд.мм.гггг',
};
